export const MARKET_OPTIONS = [
  'CR',
  'CRA',
  'CRI',
  'DEBENTURES',
  'FIAGRO',
  'FIDC',
  'FII',
] as const;

export type MarketOption = (typeof MARKET_OPTIONS)[number];

export const INSTITUTION_OPERATION_MARKETS = MARKET_OPTIONS.filter(
  (market) => market !== 'DEBENTURES',
);

const MARKET_DISPLAY_LABELS: Record<string, string> = {
  DEBENTURES: 'DEBÊNTURES',
};

export function getMarketDisplayLabel(market?: string): string {
  if (!market) {
    return '';
  }

  const key = market.toUpperCase();

  return MARKET_DISPLAY_LABELS[key] ?? key;
}
